import React from 'react';
import { convertGoogleDriveUrlForDisplay, getPlaceholderImage } from '../utils/imageUtils';
import './ProductModal.css';

export default function ProductModal({ product, isOpen, onClose }) {
  if (!isOpen || !product) return null;

  const imageUrl = product.images?.[0] || getPlaceholderImage(400, 400, 'No Image');
  const image = imageUrl ? convertGoogleDriveUrlForDisplay(imageUrl) : getPlaceholderImage(400, 400, 'No Image');
  const name = product.name || product.title || 'Product';
  const price = product.price || 0;
  const mrp = product.mrp || 0;
  const discount = mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0;
  const variants = product.variants || [];

  return (
    <div className="product-modal-overlay" onClick={onClose}>
      <div className="product-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="product-modal-close" onClick={onClose}>×</button>
        
        <div className="product-modal-body">
          <div className="product-modal-image">
            <img 
              src={image} 
              alt={name}
              onError={(e) => {
                // Prevent infinite retry loops
                e.target.src = getPlaceholderImage(400, 400, 'No Image');
                e.target.onerror = null; // Stop retrying
              }}
            />
            {discount > 0 && <div className="product-modal-badge">{discount}% OFF</div>}
          </div>

          <div className="product-modal-info">
            <h2>{name}</h2>
            
            {product.description && (
              <p className="product-modal-description">{product.description}</p>
            )}

            <div className="product-modal-price-section">
              <div className="product-modal-price">
                <span className="current-price">₹{price}</span>
                {mrp > price && (
                  <span className="original-price">₹{mrp}</span>
                )}
              </div>
              {discount > 0 && (
                <span className="product-modal-discount">You save ₹{mrp - price}</span>
              )}
            </div>

            {variants.length > 0 && (
              <div className="product-modal-variants">
                <h4>Available Options:</h4>
                <div className="variant-list">
                  {variants.map((variant, index) => (
                    <div key={variant.sku || index} className="variant-item">
                      <span className="variant-label">{variant.label}</span>
                      <span className="variant-price">₹{variant.price}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {product.category && (
              <div className="product-modal-category">
                <strong>Category:</strong> {product.category.name || product.category}
              </div>
            )}

            {product.subcategory && (
              <div className="product-modal-subcategory">
                <strong>Subcategory:</strong> {product.subcategory}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

